
const getUSZoneName = (zoneId, regions) => {
  switch (zoneId) {
    case 9: return 'AK, HI'
    case 10: return 'LIMITED CARRIER'
    default: return regions || ''
  }
}

const overrideCountryName = (zoneId) => {
  return zoneId === 116 || zoneId === 196
}

const getDescription = (zoneId, country, uniqueCountries, regions) => {
  const hasMultipleCountries = uniqueCountries.size > 1

  if (country === 'United States') {
    const zoneName = getUSZoneName(zoneId, regions)
    const separator = zoneName && !overrideCountryName(zoneId) ? ' - ' : ''
    const countryShortNotation = overrideCountryName(zoneId) ? '' : 'USA'

    if (hasMultipleCountries) {
      return `${countryShortNotation}${separator}${zoneName}`
    }

    return zoneName
  }

  if (regions) {
    return `${country} - ${regions}`
  }

  return country
}

const mapZonesFromApi = ({ pricingZones }) => {
  const uniqueCountries = new Set(pricingZones.map(z => z.country))

  const zones = pricingZones.map(({ zoneId, zoneName, country, regions }) => {
    const description = getDescription(zoneId, country, uniqueCountries, regions)
    const name = zoneName || zoneId

    if (!description) {
      return { id: zoneId, name: name }
    }

    return { id: zoneId, name: name, description: description }
  })

  return { zones: zones }
}

const mapZonesAndCountriesFromApi = ({ pricingZones }) => {
  const uniqueCountries = new Set(pricingZones.map(z => z.country))

  const zones = pricingZones.map(({ zoneId, zoneName, country, regions }) => {
    const description = getDescription(zoneId, country, uniqueCountries, regions)
    const name = zoneName || zoneId

    if (!description) {
      return { id: zoneId, name: name, country: country }
    }

    return { id: zoneId, name: name, description: description, country: country }
  })

  return { zones: zones }
}

export default {
  mapZonesFromApi,
  mapZonesAndCountriesFromApi
}
